import { render } from "./WalletLinkTest.vue?vue&type=template&id=6462226c&scoped=true"
import script from "./WalletLinkTest.vue?vue&type=script&lang=js"
export * from "./WalletLinkTest.vue?vue&type=script&lang=js"

import "./WalletLinkTest.vue?vue&type=style&index=0&id=6462226c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6462226c"]])

export default __exports__